export default __webpack_public_path__ + "static/media/webinaire_1.cc0371ad.jpg";